function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

/*
 * The two-column mobile composition for `SelectableMediaTile`.
 *
 * Two equal columns at every supported width, never wrapping to one and never
 * scrolling horizontally. It is layout only: it owns no selection state and no
 * item semantics, so a consumer maps its own options to tiles and keeps its own
 * callbacks.
 */
export default function SelectableMediaGrid({
  as: Component = "div",
  className = "",
  children,
  ...props
}) {
  return (
    <Component
      {...props}
      className={joinClassNames("lz-v2-media-grid", className)}
    >
      {children}
    </Component>
  );
}
